var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataViz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5L12 94.5C12 95.6046 12.8954 96.5 14 96.5L81.3333 96.5L106 96.5C107.105 96.5 108 95.6046 108 94.5L108 20.5C108 19.3954 107.105 18.5 106 18.5L14 18.5C12.8954 18.5 12 19.3954 12 20.5Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 53.5L23 85.5C23 86.6046 23.8954 87.5 25 87.5L30.9444 87.5L32 87.5C33.1046 87.5 34 86.6046 34 85.5L34 53.5C34 52.3954 33.1046 51.5 32 51.5L25 51.5C23.8954 51.5 23 52.3954 23 53.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40.5L44 85.5C44 86.6046 44.8954 87.5 46 87.5L51.9444 87.5L53 87.5C54.1046 87.5 55 86.6046 55 85.5L55 40.5C55 39.3954 54.1046 38.5 53 38.5L46 38.5C44.8954 38.5 44 39.3954 44 40.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47.5L65 85.5C65 86.6046 65.8954 87.5 67 87.5L72.9444 87.5L74 87.5C75.1046 87.5 76 86.6046 76 85.5L76 47.5C76 46.3954 75.1046 45.5 74 45.5L67 45.5C65.8954 45.5 65 46.3954 65 47.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31.5L86 84.5C86 85.6046 86.8954 86.5 88 86.5L93.9444 86.5L95 86.5C96.1046 86.5 97 85.6046 97 84.5L97 31.5C97 30.3954 96.1046 29.5 95 29.5L88 29.5C86.8954 29.5 86 30.3954 86 31.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 95.5C64 95.5 73.6364 76.5 90.5 76.5C107.364 76.5 117 95.5 117 95.5C117 95.5 107.364 114.5 90.5 114.5C73.6364 114.5 64 95.5 64 95.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 103.643C94.8907 103.643 98.45 99.9972 98.45 95.5C98.45 91.0028 94.8907 87.3571 90.5 87.3571C86.1093 87.3571 82.55 91.0028 82.55 95.5C82.55 99.9972 86.1093 103.643 90.5 103.643Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 103.643C94.8907 103.643 98.45 99.9972 98.45 95.5C98.45 91.0028 94.8907 87.3571 90.5 87.3571C86.1093 87.3571 82.55 91.0028 82.55 95.5C82.55 99.9972 86.1093 103.643 90.5 103.643Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64 95.5C64 95.5 73.6364 76.5 90.5 76.5C107.364 76.5 117 95.5 117 95.5C117 95.5 107.364 114.5 90.5 114.5C73.6364 114.5 64 95.5 64 95.5Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 103.643C94.8907 103.643 98.45 99.9972 98.45 95.5C98.45 91.0028 94.8907 87.3571 90.5 87.3571C86.1093 87.3571 82.55 91.0028 82.55 95.5C82.55 99.9972 86.1093 103.643 90.5 103.643Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 103.643C94.8907 103.643 98.45 99.9972 98.45 95.5C98.45 91.0028 94.8907 87.3571 90.5 87.3571C86.1093 87.3571 82.55 91.0028 82.55 95.5C82.55 99.9972 86.1093 103.643 90.5 103.643Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.5,
    cy: 95.5,
    rx: 8.5,
    ry: 9,
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataViz);
export default __webpack_public_path__ + "static/media/data-viz.ca5a1093.svg";
export { ForwardRef as ReactComponent };